import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('GraphicContainer')(css({
    display: 'flex',
    justifyContent: 'center',
    '.item-container': {
        flex: '1',
        maxWidth: ['270px', '100%'],
        padding: '0px 0px 30px 0px',
        display: 'flex',
        flexDirection: ['column', 'row'],
        alignItems: 'center',
    },
}));
themeStyles.addBaseStyles('TextContainer')(css({
    maxWidth: '300px',
    margin: ['30px 0px 0px 30px', '0px 0px 0px 30px'],
}));
themeStyles.addBaseStyles('ItemContainer')(css({
    '.speedometer': {
        display: 'flex',
        maxWidth: '540px',
        padding: ['30px 0', '30px 0 30px 30px'],
    },
}));
themeStyles.addBaseStyles('BodyTextContainer')(css({
    my: ['xs', 's'],
    p: {
        mb: ['default'],
    },
    h6: {
        mb: ['4px'],
        color: ['blue'],
    },
    textAlign: ['center', 'left'],
}));
themeStyles.addBaseStyles('Container')(css({
    position: 'relative',
    height: 'fit-content',
}));
themeStyles.addBaseStyles('SVG')(({ color, theme }) => css({
    margin: '0 auto',
    borderRadius: '50%',
    display: 'block',
    '.chart-indicator': {
        stroke: color || theme.colors.grey[1],
    },
}));
themeStyles.addBaseStyles('ChartTrack')(({ theme }) => css({
    fill: 'transparent',
    stroke: theme.colors.grey[1],
    strokeWidth: '26',
}));
themeStyles.addBaseStyles('ChartTrackIndicator')(({ theme }) => css({
    fill: 'transparent',
    stroke: theme.colors.grey,
    strokeWidth: '26',
    strokeDasharray: '0 10000',
    transition: 'stroke-dasharray 1s ease',
}));
themeStyles.addBaseStyles('ChartValueContainer')(css({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -30%)',
    display: 'flex',
    alignItems: 'flex-start',
}));
themeStyles.addBaseStyles('ChartValue')(({ theme }) => css({
    fontFamily: 'default',
    color: theme.greyDark,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '40px',
    lineHeight: '30px',
    height: '30px',
}));
themeStyles.addBaseStyles('ChartValueSymbol')(({ theme }) => css({
    fontFamily: theme.fontFamilyBase,
    color: theme.greyDark,
    fontStyle: 'default',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '18px',
    width: '17px',
    height: '18px',
}));
export default themeStyles;
